// @flow strict

import { path, imgSrc } from "~common/utils";

export const PLAYER_1: Player = "lady-neros";
export const PLAYER_2: Player = "imanol-arga";
export const PLAYER_3: Player = "mia-la-staffa";
export const PLAYER_4: Player = "elman-gante";
export const PLAYER_5: Player = "jo-frau-de-fiscaal";
export const PLAYER_6: Player = "reidel-birle";

export const PLAYERS: [Player, Player, Player, Player, Player, Player] = [
  PLAYER_1,
  PLAYER_2,
  PLAYER_3,
  PLAYER_4,
  PLAYER_5,
  PLAYER_6,
];

export const NAME_PLAYER: Map<Player, string> = playersMap([
  "Lady Neros",
  "Imanol Arga",
  "Mia La Staffa",
  "Elman Gante",
  "Jo Frau de Fiscäal",
  "Reidel Birle",
]);

export opaque type Player: string = string;

export function asPlayer(player: ?string): ?Player {
  switch (player) {
    case "lady-neros":
      return "lady-neros";
    case "imanol-arga":
      return "imanol-arga";
    case "mia-la-staffa":
      return "mia-la-staffa";
    case "elman-gante":
      return "elman-gante";
    case "jo-frau-de-fiscaal":
      return "jo-frau-de-fiscaal";
    case "reidel-birle":
      return "reidel-birle";
    default:
      return;
  }
}

export function playersMap<T>(values: [T, T, T, T, T, T]): Map<Player, T> {
  return new Map(PLAYERS.map((p, idx) => [p, values[idx]]));
}
export const AVATAR_PLAYER: Map<Player, string> = playersMap([
  imgSrc("/images/robin-hood/avatars/1.png"),
  imgSrc("/images/robin-hood/avatars/2.png"),
  imgSrc("/images/robin-hood/avatars/3.png"),
  imgSrc("/images/robin-hood/avatars/4.png"),
  imgSrc("/images/robin-hood/avatars/5.png"),
  imgSrc("/images/robin-hood/avatars/6.png"),
]);

export const PLAYER_PARAM: Player = ":player";

export const PATHS = {
  JOIN: (codigo: string): string => `${path("join")}?token=${codigo}`,
  AGENTES: (): string => path("agentes"),
  INICIAL: (player: Player): string => path(`prueba-inicial/${player}`),
  CONSOLA: (player: Player): string => path(`prueba-consola/${player}`),
  DIGITOS: (player: Player): string => path(`prueba-digitos/${player}`),
  AHORCADO: (player: Player): string => path(`prueba-ahorcado/${player}`),
  CASILLAS: (player: Player): string => path(`prueba-casillas/${player}`),
  COLORES: (player: Player): string => path(`prueba-colores/${player}`),
  POKER: (player: Player): string => path(`prueba-poker/${player}`),
  SONIDOS: (player: Player): string => path(`prueba-sonidos/${player}`),
  FINAL: (player: Player): string => path(`prueba-final/${player}`),
};

export const UNREGISTERED_PATHS = {
  HOME: (): string => path(""),
  EQUIPO: (): string => path("equipo"),
};

export const TOTAL_SECONDS = 60 * 60;
export const EXTRA_SECONDS = 10 * 60;
